import { PaymentCard } from "../types";
import { CardView } from "./CardView";

interface Props {
  card: PaymentCard;
}

const CardBlock = ({ card }: Props) => {
  return (
    <div className="bg-surface-subtle flex items-center gap-3 rounded-lg border border-[#EBEDF2] px-5 py-3">
      <CardView card={card} />
    </div>
  );
};

export default CardBlock;
